<template>
    <div>
        <coupon-member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page"></coupon-member-filter-link>
         <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                            :paginationData="filterSet.page"></member-filter-link>
        <coupon-member-list-link :listLayout="listLayout" :paginationData="filterSet.page" :memberData="List"></coupon-member-list-link>
        <member-pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="memberType"></member-pagination-link>
    </div>
</template>

<script>
    import CouponMemberFilterLink from "@/components/coupon/CouponMemberFilterLink";
    import CouponMemberListLink from "@/components/coupon/CouponMemberListLink";
    import MemberPaginationLink from "@/components/coupon/MemberPaginationLink";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import alertMixins from "@/mixins/alertMixins";
    import couponUtil from "@/components/coupon/CouponUtil";
    import EventBus from "@/utils/event-bus";
    import Swal from 'sweetalert2'

    import {setExcelConfig, runExcelDown} from "@/mixins/excelApiDown";
    const {filterConfig} = couponUtil;

    export default {
        name: "CouponMemberListComponent",
        mixins: [filterMixins,listMixins,alertMixins,couponUtil],
        components: {CouponMemberFilterLink,CouponMemberListLink,MemberPaginationLink},
        provide() {
            return {
                setPage: this.setPage,
                setFilter: this.setFilter,
                couponMemberListSetData: this.setData,
            }
        },
        inject: ['changeLoading'],
        props: {
            memberType: {default: ''},
            couponKey: {default: 0},
        },
        data() {
            return {
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',
                // couponKey: '',
                getFunc: '',
                listApiParamSet: {},
                deleteFunc: ''
                // pageRow: 10,


                /*필터 classname*/

            }
        },
        created() {
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.initConfig();
        },
        mounted() {
            this.getList(true);
            EventBus.$on('deleteMemberCoupon', this.deleteMemberCoupon);
          EventBus.$on('getList', this.getList);
          EventBus.$on('downloadExcel', this.downloadExcel);
        },
        beforeDestroy() {
            EventBus.$off('deleteMemberCoupon');
          EventBus.$off('getList');
          EventBus.$off('downloadExcel');
        },
        destroyed() {},
        computed: {
        },
        methods: {
            setData(type, value) {
                this[type] = value;
            },
            initConfig() {
                let config = this.returnCouponConfig(this.memberType)
                this.listLayout= config.listLayout;
                this.filterLayout = config.filterLayout;
                this.paginationLayout = config.paginationLayout;
                this.getFunc = config.getFunc;
                this.listApiParamSet = config.listApiParamSet;
                this.deleteFunc = config.deleteFunc;

                this.listApiParamSet.c_idx = this.couponKey;

                let listOptions = {
                    url : this.$api.$coupon[this.getFunc],
                    defaultParams : this.listApiParamSet,
                }
                this.initList('api', listOptions);
            },
            deleteMemberCoupon(id) {
                Swal.fire({
                title: '삭제 사유',
                text: '쿠폰 삭제 사유를 입력해주세요.',
                confirmButtonText: '확인',
                cancelButtonText: '취소',
                showCancelButton: true,
                inputAutoTrim: false,
                inputPlaceholder: '삭제 사유를 입력해주세요.',
                input: 'text',
                customClass: 'koreanSSam',
                inputValidator: (value) => {
                    if (!value) {
                        return '삭제 사유를 입력해주세요!'
                    }
                },
                preConfirm: (value) => {
                    let params = {}
                    params.cbm_idx = id
                    params.delete_reason = value
                    try {
                        this.$api.$coupon[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type == 1) {
                                    this.$router.go();
                                    this.errorAlert(res.Info.reason);                            
                                } else {
                                    this.errorAlert(res.Info.reason);
                                }
                        })
                    } catch (e) {
                        this.changeLoading(false);
                            console.log(e);
                    }
                }
            })
                console.log(id);
            },
            downloadExcel() {
            let listOptions = {
                url: this.$api,
                defaultParams: {
                    c_idx:this.couponKey,
                    type:0,
                    odc:'cl_idx',
                    odd:'desc',
                },
            }
            this.initList('api', listOptions);
            let filterObj = {
                page: {},
                filter: {},
                sort: {},
            }
            let params =  this.listClass.makeParams(filterObj);

            setExcelConfig(`coupon/link/excel`, 'CouponList')
            runExcelDown(params);
            },

        },
        watch: {},
    }
</script>

<style scoped>

</style>